import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { I18nService } from '@core/i18n/i18n.service';
import { ClarityTrackingService } from '@core/analytics/clarity-tracking.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
    // Inyección para inicializar el idioma al arrancar la aplicación
    readonly i18n = inject(I18nService);

    private readonly platformId = inject(PLATFORM_ID);
    private readonly clarityTracking = inject(ClarityTrackingService);

    ngOnInit(): void {
        // Analítica de comportamiento (mapas de calor + grabaciones): solo en navegador.
        if (isPlatformBrowser(this.platformId)) {
            void this.clarityTracking.start();
        }
    }
}
